import { AfterViewInit, Component, Renderer2, ViewChild } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";

@Component({
  selector: "select-popover",
  templateUrl: "select-popover-component.html",
})
export class SelectPopoverComponent implements AfterViewInit {
  options: any[];
  width: any;
  selectedOption: any;

  @ViewChild("list") list;

  constructor(
    private navParams: NavParams,
    private viewCtrl: ViewController,
    private renderer: Renderer2
  ) {
    this.options = this.navParams.get("options");
    this.width = this.navParams.get("width");
    this.selectedOption = this.navParams.get("selectedOption");
  }

  ngAfterViewInit() {
    this.renderer.setStyle(this.list.nativeElement, "width", `${this.width}px`);
  }

  onSelectOption(option) {
    this.viewCtrl.dismiss(option, null, { animate: false });
  }
}



// WEBPACK FOOTER //
// ./src/components/common/single-select-dropdown/select-popover-component.ts